export const SET_RANKING_LOADING = 'SET_RANKING_LOADING';
export const GET_RANKING_LIST_SUCCESS = 'GET_RANKING_LIST_SUCCESS';
export const GET_RANKING_DETAIL_SUCCESS = 'GET_RANKING_DETAIL_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
